var webApp = angular.module('webApp', ['core', 'ngRoute', 'ngAnimate', 'ngMessages', 'ngSanitize', 'dndLists', 'ngFileUpload', 'nvd3'])
.run( function($route, $rootScope, $location, $timeout, $http, $q, $templateCache, $sce) {
    var _queue = [];

    $rootScope.loading = true;

    FastClick.attach(document.body);
    
    $rootScope.go = function(_path){
        $location.path(_path);
    }
})
.config(function($routeProvider, $qProvider) {
    $qProvider.errorOnUnhandledRejections(false);

    $routeProvider
    .when("/project/:project?", {
        controller: 'projectCtrl',
        name: 'project',
        templateUrl : './templates/project.html',
        cache: false,
        resolve: {
            "check": function ($rootScope, $location, $http) {

            }
        }
    })
    .when("/data/:project?", {
        controller: 'dataCtrl',
        name: 'data',
        templateUrl : './templates/data.html',
        cache: false,
        resolve: {
            "check": function ($rootScope, $location, $http) {

            }
        }
    })
    .when("/home", {
        controller: 'homeCtrl',
        name: 'home',
        templateUrl : './templates/home.html',
        cache: false,
        resolve: {
            "check": function ($rootScope, $location, $http) {

            }
        }
    })
    .when("/tools/:tool?", {
        controller: 'toolsCtrl',
        name: 'tools',
        templateUrl : './templates/tools.html',
        cache: false,
        resolve: {
            "check": function ($rootScope, $location, $http) {

            }
        }
    })
    .when("/journey/:type", {
        controller: 'journeyCtrl',
        name: 'journey',
        templateUrl : './templates/journey.html',
        cache: false,
        resolve: {
            "check": function ($rootScope, $location, $http) {

            }
        }
    })
    .otherwise({ redirectTo: '/home' });
});

(function($){
    $(document).on('ready', function(){ });
    $(document).on('touchstart', function (e) { });
})(jQuery, this);

function generateHash(length){
    if(length == undefined){
        length = 8;
    }
    var text = "";
    var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

    for (var i = 0; i < length; i++){
        text += possible.charAt(Math.floor(Math.random() * possible.length));
    }

    return text;
}

function randInt(min, max){
    var _range = (max - min) + 1;
    return Math.floor(Math.random() * _range) + min;
}
function randFloat(min, max){
    var _range = (max - min) + 1;
    return (Math.random() * _range) + min;
}

// Object.prototype.length = function(){
//     return Object.keys(this).length;
// }

Array.prototype.exists = function(test){
    var me = this;
    var _return = false;
    
    $(me).each(function(){
        if(typeof test == 'string'){
            if(test == this){
                _return = true;
            }
        }
        else {
            if(angular.equals(this, test)){
                _return = true;
            }
        }
    });

    return _return;
}

Array.prototype.remove = function(test){
    var me = this;
    var _item = -1;
    $(me).each(function(i){
        if(angular.equals(this, test)){
            _item = i;
        }
    });
    if(_item >= 0){
        this.splice(_item, 1);
    }
}

Number.prototype.floor = function(){
    return Math.floor(this);
}

String.prototype.ucFirst = function(){
    return this.charAt(0).toUpperCase() + this.slice(1);
}

String.prototype.replaceAll = function(target, replacement) {
  return this.split(target).join(replacement);
}

String.prototype.toUrl = function(){
    st = this.toLowerCase();
    st = st.replace(/[\u00C0-\u00C5]/ig,'a')
    st = st.replace(/[\u00C8-\u00CB]/ig,'e')
    st = st.replace(/[\u00CC-\u00CF]/ig,'i')
    st = st.replace(/[\u00D2-\u00D6]/ig,'o')
    st = st.replace(/[\u00D9-\u00DC]/ig,'u')
    st = st.replace(/[\u00D1]/ig,'n')
    st = st.replace(/'+/gi,'')
    st = st.replace(/[^a-z0-9]+/gi,'')
    st = st.replace(/ /ig,'');
    st = st.replace(/[\-]{2}/g,'');
    if(st.substr(0,1) == '-'){
        st = st.substr(1);
    }
    //st = (st.replace(/[^a-z\- ]*/gi,''));
    return st;
}
String.prototype.toSlug = function(){
    st = this.toLowerCase();
    st = st.replace(/[\u00C0-\u00C5]/ig,'a')
    st = st.replace(/[\u00C8-\u00CB]/ig,'e')
    st = st.replace(/[\u00CC-\u00CF]/ig,'i')
    st = st.replace(/[\u00D2-\u00D6]/ig,'o')
    st = st.replace(/[\u00D9-\u00DC]/ig,'u')
    st = st.replace(/[\u00D1]/ig,'n')
    st = st.replace(/'+/gi,'')
    st = st.replace(/[^a-z0-9]+/gi,'-')
    st = st.replace(/ /ig,'-');
    st = st.replace(/[\-]{2}/g,'');
    if(st.substr(0,1) == '-'){
        st = st.substr(1);
    }
    //st = (st.replace(/[^a-z\- ]*/gi,''));
    return st;
}